import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Row, Col, Form, OverlayTrigger, Container, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { MdEdit, MdDelete, MdAddCircle, MdFilterList } from 'react-icons/md';
import DataTable from 'react-data-table-component';
import { ToastContainer, toast } from 'react-toastify';
import Tooltip from "@mui/material/Tooltip";
import Header from '../../components/layout/header/header';
import LeftNav from '../../components/layout/leftNav/leftNav';
 import axios from "axios";
import loading from '../../assets/images/common/loading.gif';
import AppDataGrid from "../../components/common/AppDataGrid";

const GalleryList = () => {
    const userData = sessionStorage.getItem('user');
    const userObj = JSON.parse(userData);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [galleryList, setGalleryList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const navigate = useNavigate();

    const [filter, setFilter] = useState({
        gallery_name: '',
        event_date: ''
    });

    const handleShowFilterModal = () => setShowFilterModal(true);
    const handleCloseFilterModal = () => setShowFilterModal(false);

    useEffect(() => {
        fetchGallery();
    }, []);

   

const fetchGallery = async () => {
  setIsLoading(true);
  try {
    const res = await axios.post(
      `${baseUrl}/main/gallery`,
      { action: "READ", school_id: userObj.school_id },
      { headers: { "Content-Type": "application/json" } }
    );

    const data = res.data || [];
    setGalleryList(data);
    setFilteredList(data);
  } catch (err) {
    toast.error("Failed to fetch gallery");
  } finally {
    setIsLoading(false);
  }
};


    const handleSearchChange = (e) => {
        const value = e.target.value.toLowerCase();
        setFilterText(value);
        const filtered = (galleryList || []).filter(
            item =>
                item.gallery_name?.toLowerCase().includes(value) ||
                item.event_date?.toLowerCase().includes(value)
        );
        setFilteredList(filtered);
    };

    const handleEdit = (row) => {
        navigate('/addgallery', { state: { galleryData: row } });
    };

   const handleDelete = async (row) => {
  if (!window.confirm("Are you sure you want to delete this gallery?")) return;

  try {
    await axios.post(
      `${baseUrl}/main/gallery`,
      {
        action: "DELETE",
        gallery_id: row.gallery_id,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    toast.success("Gallery deleted");
    fetchGallery();
  } catch (error) {
    toast.error("Failed to delete gallery");
  }
};

    const columns = [
        {
            field: "gallery_name",
            headerName: "Gallery Name",
            flex: 1,
            sortable: true,
            renderCell: (params) => (
                <Tooltip title={params.value || ""}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "event_date",
            headerName: "Event Date",
            flex: 1,
            sortable: true,
            renderCell: (params) => {
                let dateOnly = '';
                if (params.value) {
                    const dateObj = new Date(params.value);
                    if (!isNaN(dateObj)) {
                        dateOnly = dateObj.toISOString().split('T')[0];
                    } else {
                        dateOnly = params.value;
                    }
                }
                return (
                    <Tooltip title={params.value || ""}>
                        <span>{dateOnly}</span>
                    </Tooltip>
                );
            },
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 1,
            sortable: false,
            renderCell: (params) => {
                const isValid = params.row.event_date && params.row.event_date !== "No Records Found";

                return isValid ? (
                    <div className="tableActions">
                        <Tooltip title="Edit">
                            <span
                                className="commonActionIcons"
                                onClick={() => handleEdit(params.row)}
                            >
                                <MdEdit />
                            </span>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <span
                                className="commonActionIcons"
                                onClick={() => handleDelete(params.row)}
                            >
                                <MdDelete />
                            </span>
                        </Tooltip>
                    </div>
                ) : null;
            },
        },
    ];

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        const filtered = (galleryList || []).filter(item =>
            (!filter.gallery_name || item.gallery_name?.toLowerCase().includes(filter.gallery_name.toLowerCase())) &&
            (!filter.event_date || item.event_date === filter.event_date)
        );
        setFilteredList(filtered);
        handleCloseFilterModal();
    };

    const handleFilterReset = () => {
        setFilter({ gallery_name: '', event_date: '' });
        setFilteredList(galleryList);
    };

    return (
        <div className="pageBody">
            <ToastContainer />
            <Container fluid>
                <div className="commonDataTableHead">
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                            <h6 className="commonTableTitle">Gallery List</h6>
                        </div>
                        <div>
                            <input
                                type="text"
                                placeholder="Search..."
                                value={filterText}
                                className="searchInput"
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div className="d-flex align-items-center" style={{ gap: 6 }}>
                            <OverlayTrigger placement="top" overlay={<Tooltip title="Filter"><span>Filter</span></Tooltip>}>
                                <Button className="secondaryBtn" onClick={handleShowFilterModal}>
                                    <MdFilterList />
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip title="Add"><span>Add</span></Tooltip>}>
                                <Button className="primaryBtn" onClick={() => navigate('/addgallery')}>
                                    <MdAddCircle />
                                </Button>
                            </OverlayTrigger>
                        </div>
                    </div>
                </div>
                <div className="commonTable height100">
                    <div className="tableBody">
                        {isLoading ? (
                            <div className="loadingContainer">
                                <img src={loading} alt="Loading..." className="loadingGif" />
                            </div>
                        ) : (
                            <AppDataGrid
                                rows={Array.isArray(filteredList) ? filteredList : []}
                                columns={columns}
                                getRowId={(row) =>
                                    row.gallery_id ??
                                    `${row.gallery_name || 'gallery'}-${row.event_date || 'no-date'}`
                                }
                                showToolbar={false}
                                pagination={Array.isArray(filteredList) && filteredList.length > 0}
                                pageSizeOptions={[10, 20, 50]}
                                density="compact"
                                sx={{
                                    maxHeight: 600,
                                }}
                            />
                        )}
                    </div>
                </div>

            </Container>

            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>

                <Modal.Body className="modalBodyScrollable">
                    <Form id="filterForm" onSubmit={handleFilterSubmit}>
                        <Row>
                            <Col xs={12}>
                                <div className="commonInput">
                                    <Form.Group controlId="galleryName">
                                        <Form.Label>Gallery Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Gallery Name"
                                            value={filter.gallery_name}
                                            onChange={(e) => setFilter({ ...filter, gallery_name: e.target.value })}
                                            maxLength={100}
                                        />
                                    </Form.Group>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div className="commonInput">
                                    <Form.Group controlId="eventDate">
                                        <Form.Label>Event Date</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={filter.event_date}
                                            onChange={(e) => setFilter({ ...filter, event_date: e.target.value })}
                                        />
                                    </Form.Group>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>

                <Modal.Footer className="modalFooterFixed">
                    <div>
                        <Button variant="secondary" className="btn-info clearBtn" onClick={handleFilterReset}>
                            Reset
                        </Button>
                    </div>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn" onClick={handleCloseFilterModal}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            type="submit"
                            className="btn-success primaryBtn"
                            form="filterForm"
                            onClick={handleCloseFilterModal}
                        >
                            Search
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default GalleryList;
